(function () {
  function initTopMessages() {
    var bar = document.querySelector('[data-top-messages]');
    if (!bar) return;
    var items = bar.querySelectorAll('.top-messages__item');
    if (items.length < 2) return;
    var shell = document.querySelector('[data-header-shell]');
    var raw = shell && shell.getAttribute('data-promo-interval');
    var intervalMs = parseInt(raw, 10);
    if (!intervalMs || intervalMs < 2000) intervalMs = 5000;

    var i = 0;
    var timer = null;
    function tick() {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }
    function start() {
      if (timer) return;
      timer = setInterval(tick, intervalMs);
    }
    function stop() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }

    start();
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
  }

  function initHeaderScrollShadow() {
    var shell = document.querySelector('[data-header-shell].header-shell--shadow-on-scroll');
    if (!shell) return;
    function onScroll() {
      if (window.scrollY > 10) shell.classList.add('is-scrolled');
      else shell.classList.remove('is-scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-menu-open]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    var closeBtn = document.querySelector('[data-mobile-menu-close]');
    var backdrop = document.querySelector('[data-mobile-drawer-backdrop]');
    if (!toggle || !drawer) return;

    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var focusTarget = drawer.querySelector('.mobile-drawer__search input') || closeBtn;
      if (focusTarget && typeof focusTarget.focus === 'function') {
        window.setTimeout(function () {
          focusTarget.focus();
        }, 0);
      }
    }
    function shut() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
      lastFocus = null;
    }

    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', shut);
    if (backdrop) backdrop.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) shut();
    });
  }

  function initReadMore() {
    document.querySelectorAll('[data-read-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var root = btn.closest('.copy-block');
        if (!root) return;
        root.classList.toggle('is-collapsed');
        btn.textContent = root.classList.contains('is-collapsed') ? 'READ MORE' : 'READ LESS';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTopMessages();
    initHeaderScrollShadow();
    initMobileNav();
    initReadMore();
  });
})();
